import React from 'react';

const ResumeJobMatchConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/match/resume-job-match',
			component: React.lazy(() => import('./ResumeJobMatch'))
		}
	]
};

export default ResumeJobMatchConfig;
